module.exports = __webpack_public_path__ + "static/Intro-min-4ada994098049dc680a65b7f4ae7486e.png";